import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Permission, DeliveryNoteDTO } from 'core/api';
import { PrintFacade } from 'pos/facades';

declare global {
	interface CommandType {
		printDeliveryNoteCoupons: (deliveryNote: DeliveryNoteDTO) => Promise<Result>
	}
}

Command.register('printDeliveryNoteCoupons', Preconditions.and(Preconditions.ensure(Permission.Coupon_Print), Preconditions.ensureIsNotLite), async (deliveryNote: DeliveryNoteDTO) => {
	await PrintFacade.printDeliveryNoteCoupons(deliveryNote.Id);
	return Result.ok();
});
